module.exports = __webpack_public_path__ + "assets/img/Rectangle770.913cceab.png";